var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-col',[_c('div',{staticClass:"provisioning_success_container"},[_c('a-button',{staticClass:"green_bg step_btn",attrs:{"block":"","size":"large"},on:{"click":function($event){$event.preventDefault();return _vm.enterMonitorPage.apply(null, arguments)}}},[_vm._v("進入監控畫面")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }